import http from './http'

class Tour {
  end () {
    return http.put('/tours/end_tour')
  }

  dashboardEnd () {
    return http.put('/tour/end_tour')
  }
}

export default new Tour()



// WEBPACK FOOTER //
// ./src/services/tour.js